// apps/share-web/src/player-view/setlist-nav.ts
//
// Соседи песни по сетлисту — тот же расчёт, что в mount.ts (порядок рельсы =
// сортировка по position, чтобы «следующая» совпадала со строкой ниже).
import { getState } from '../state.js';

export interface SetlistNavItem { shareId: string; songName: string | null; }

export interface SetlistNav {
  /** Песни сетлиста в порядке рельсы. */
  items: SetlistNavItem[];
  /** Индекс этой песни в items; −1 — песни в этом сетлисте нет. */
  curIdx: number;
  prevShareId: string | null;
  nextShareId: string | null;
  /** «N из M» — только в сетлисте больше чем из одной песни. */
  position: { n: number; total: number } | null;
}

interface RawItem { position: number; shareId: string; songName?: string | null; }

export function setlistNav(shareId: string, items: ReadonlyArray<RawItem> = getState().setlistItems): SetlistNav {
  const sorted = [...items].sort((a, b) => a.position - b.position);
  const curIdx = sorted.findIndex((it) => it.shareId === shareId);
  return {
    items: sorted.map((it) => ({ shareId: it.shareId, songName: it.songName ?? null })),
    curIdx,
    prevShareId: curIdx > 0 ? sorted[curIdx - 1].shareId : null,
    nextShareId: curIdx >= 0 && curIdx < sorted.length - 1 ? sorted[curIdx + 1].shareId : null,
    position: sorted.length > 1 && curIdx >= 0 ? { n: curIdx + 1, total: sorted.length } : null,
  };
}
